import { Directive, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { CognitoService } from '@dash/randy/security/service/cognito.service';
import { Subscription } from 'rxjs';

@Directive({
    selector: '[appAuthPermissionCheck]',
    standalone: false
})
export class AuthPermissionCheckDirective implements OnDestroy {
  private permissionString: string | Array<string>;
  private permissionsSubscription: Subscription;
  private hasView = false;

  @Input() set appAuthPermissionCheck(value: string | Array<string>) {
    this.permissionString = value;
    this.validatePermissions();
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private cognitoService: CognitoService,
  ) {
    this.permissionsSubscription = this.cognitoService.permissions$.subscribe(() => {
      this.validatePermissions();
    });
  }

  ngOnDestroy(): void {
    this.permissionsSubscription.unsubscribe();
  }

  private validatePermissions(): void {
    const permissionString = this.permissionString;
    if (!permissionString) {
      return;
    }

    let result = false;

    if (this.cognitoService.isAuthenticated()) {
      if (Array.isArray(permissionString)) {
        result = permissionString.some(permission => this.cognitoService.getPermissions(permission));
      } else {
        result = this.cognitoService.getPermissions(permissionString);
      }
    }

    if (result && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!result && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
